import * as React from 'react'
import { ReactElement, useState } from 'react'
import BaseList from '../../../components/List/BaseList'
import { FormikContextType, useFormikContext } from 'formik'
import { FileMutationDto } from '../../../config/fileConfig'
import { Button } from '@fluentui/react-components'
import { GuestAdd24Regular } from '@fluentui/react-icons'
import UserTierDialog from '../../Dialog/UserTier/UserTierDialog'
import { BaseTierDto } from '../../../config/finance/financeConfig'
import { UserTierFormProps } from './UserTierForm'
import { UserDto } from '../../../config/userConfig'
import { useTranslation } from 'react-i18next'

export type UserBaseTierListProps<T extends BaseTierDto> = {
    defaultTierValue: () => T
    createListItem: (index: number, item: T, editTier: (index: number) => void) => ReactElement
    createTierFormContainer: (
        props: UserTierFormProps<T>,
        fileContext: FormikContextType<FileMutationDto>,
        selectableUsers: UserDto[],
    ) => React.ReactElement
}

export enum UserTierAction {
    ADD = 'add',
    EDIT = 'edit',
}

export default function UserTierList<T extends BaseTierDto>(props: UserBaseTierListProps<T>): ReactElement {
    const { t: translate } = useTranslation()
    const { values, setFieldValue } = useFormikContext<FileMutationDto>()
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [index, setIndex] = useState(null)
    const [action, setAction] = useState<UserTierAction>()
    const addNewTier = () => {
        const tiers = [...(values.tiers ? values.tiers : []), props.defaultTierValue()]
        setFieldValue('tiers', tiers)
        setAction(UserTierAction.ADD)
        setIndex(tiers.length - 1)
        setOpenDialog(true)
    }
    const editTier = (index: number) => {
        setAction(UserTierAction.EDIT)
        setIndex(index)
        setOpenDialog(true)
    }

    return (
        <>
            <Button style={{ marginTop: 10 }} appearance="primary" icon={<GuestAdd24Regular />} onClick={addNewTier}>
                {translate('file.edit.form.finance.rates.tier.add')}
            </Button>
            {values.tiers?.length > 0 && (
                <BaseList<BaseTierDto> items={values.tiers}>
                    {(item: BaseTierDto, index: number) => props.createListItem(index, item as T, editTier)}
                </BaseList>
            )}
            <UserTierDialog<T>
                show={openDialog}
                setOpen={setOpenDialog}
                initialValues={(values.tiers ? values.tiers[index] || undefined : undefined) as T}
                index={index}
                action={action}
                {...props}
            />
        </>
    )
}
